import { render, staticRenderFns } from "./ProfilePosts.vue?vue&type=template&id=4298e3c0&scoped=true&"
import script from "./ProfilePosts.vue?vue&type=script&lang=js&"
export * from "./ProfilePosts.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePosts.vue?vue&type=style&index=0&id=4298e3c0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4298e3c0",
  null
  
)

export default component.exports